import { render } from "./App.vue?vue&type=template&id=496bfcfd&bindings={\"stage\":\"setup\",\"width\":\"setup\",\"height\":\"setup\",\"radius\":\"setup\",\"center\":\"setup\",\"items\":\"setup\",\"bg\":\"setup\",\"sunburstWedges\":\"setup\",\"arrowImageObj\":\"setup\",\"onItemsUpdate\":\"setup\",\"isSettingsOpen\":\"setup\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script